import { Button, TextField, Typography } from "@mui/material";

import Modal from "../../../../../../global/Modal";
import Svg from "../../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../../ui library/HNSColors";
import sharedStyles from "../../../modules/DynamicSection/styles/formStyles";

const NoteModal = ({
  closeModal,
  formData,
  handleAnswerChange,
  questionKey,
  selectedInjury,
  setFormData,
  setSelectedInjury,
}) => {
  function handleApply() {
    const updatedData = formData.map((item) =>
      item.body_part === selectedInjury.body_part ? { ...item, ...selectedInjury } : item
    );
    setFormData(updatedData);
    handleAnswerChange(questionKey, {
      injuries: updatedData,
    });
    setTimeout(() => {
      closeModal();
    }, 500);
  }

  return (
    <Modal open onClose={closeModal}>
      <div className="px-2 py-4">
        <Typography
          variant="h5"
          fontWeight="medium"
          className="mb-4"
          sx={sharedStyles.label(false)}
        >
          <Svg
            sx={{
              color: HNSColors.primary[500],
              width: "18px",
              marginRight: "0.5rem",
            }}
            name="his-edit"
          />{" "}
          Add notes to describe {selectedInjury.body_part}
        </Typography>
        <TextField
          fullWidth
          size="small"
          value={selectedInjury.pain_description}
          variant="outlined"
          onChange={({ target: { value: newValue } }) =>
            setSelectedInjury((prev) => ({
              ...prev,
              pain_description: newValue,
            }))
          }
          multiline
          rows={3}
          sx={sharedStyles.textField}
        />
        <div className="mt-4 flex w-full gap-4">
          <Button
            sx={{
              color: HNSColors.secondary[500],
              border: `1px solid ${HNSColors.secondary[500]}`,
              "&:hover": {
                background: HNSColors.secondary[900],
                border: `1px solid ${HNSColors.secondary[500]}`,
              },
            }}
            className="w-1/2 rounded-3xl bg-white px-8 text-sm normal-case"
            variant="outlined"
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            sx={{
              background: HNSColors.secondary[500],
              "&:hover": {
                background: HNSColors.secondary[400],
              },
            }}
            className="w-1/2 rounded-3xl px-8 text-sm normal-case"
            variant="contained"
            onClick={handleApply}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NoteModal;
